import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { POService } from '../../services/po.service';
import { map, startWith } from 'rxjs/operators';
import { ReportService } from '../../services/report.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { formatDate } from '@angular/common';
import { Methods } from '../../shared/methods';
import swal from 'sweetalert2';
import { GuiGuard } from '../../shared/guard/base-gui-guard';
import { CompanylinkedService } from "../../services/companylinked.service";

export interface UserList {
  value: string;
  name: string;
}

declare const $: any;

@Component({
  selector: 'app-physicaldestruction',
  templateUrl: './physicaldestruction.component.html',
  styleUrls: ['./physicaldestruction.component.css'],
  providers: [POService, CompanylinkedService]
})
export class PhysicaldestructionComponent implements OnInit {

  public mtds: Methods = new Methods();

  public statusContainerByPhysicalDestruction: boolean = false;
  public destructionclientscompany: any = '';
  myControlCompaniesDestruction = new FormControl();
  public loading: boolean = false;
  public responseDestructionReport: any[] = [];
  public destructionclientsname: string = '';
  public destructionclientscompany2: any;
  public token;
  public poListDestruction: any[] = [];
  public poSelected;
  filteredCompaniesDestruction: Observable<UserList[]>;
  companiesListDestruction: UserList[] = [];
  public poSelectedDestruction;
  public destructionpo: string = '';
  public cerrado = false;
  public desbloquear = false;
  public currentReport = 0;
  public destructionposelected: string = '';
  public summaryTotal = {};
  public destructionManuallySerialNumber = '';
  public destructionManuallyMake = '';
  public destructionManuallyModel = '';
  public destructionManuallySerialCapacity = '';
  public saving = false;
  public reportSaved = 0;
  public identity;
  public destructionManuallyDate = '';
  public destructionShowAddManually: boolean = false;
  public destructionshowMsgInfoResults = 0;
  public destructionshowMsgSearchingNotResults = 0;
  public destructionshowMsgSearchingFailedResults = 0;
  public msgerrordestruction = '';
  public saveunlock = false;

  public typeReport = 'basic';

  constructor(
    private gui: GuiGuard,
    private _router: Router,
    private _reportService: ReportService,
    private _companylinkedService: CompanylinkedService,
    private _poService: POService
  ) {
    this.identity = JSON.parse(localStorage.getItem("identity"));
    this.token = JSON.parse(localStorage.getItem("token"));
    this.getAllCompanies();
  }

  ngOnInit() {
    this.filteredCompaniesDestruction = this.myControlCompaniesDestruction.valueChanges.pipe(
      startWith<string | UserList>(''),
      map(value => typeof value === 'string' ? value : value.name),
      map(name => name ? this._filterCompaniesDestruction(name) : this.companiesListDestruction.slice())
    );
  }

  private _filterCompaniesDestruction(name: string): UserList[] {
    const filterValue = name.toLowerCase();

    return this.companiesListDestruction.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  getAllCompanies() {
    this._companylinkedService.getAllCompaniesLite(this.token, 'all').subscribe(
      response => {
        console.log(response);
        if (response.status == 'success') {
          response.data.forEach((element) => {
            this.companiesListDestruction.push({ value: element.id, name: element.name + ' # ' + element.id });
          });
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  containerByPhysicalDestruction() {
    this.statusContainerByPhysicalDestruction = !this.statusContainerByPhysicalDestruction;
  }

  clean() {
    this.getReport();
  }

  OnHumanSelectedDestruction(event: any) {


    this.loading = true;
    var res = event.viewValue.split("#");
    this.responseDestructionReport = [];

    this.destructionclientscompany = res[0].trim();
    this.destructionclientsname = res[0].trim();
    console.log(this.destructionclientsname);
    let valorEnviar = res[1].trim();
    this.destructionclientscompany2 = res[1].trim();
    $("#poInputDestruction").show();

    this._poService.getAllPOsLiteByCompany(this.token, valorEnviar).subscribe(
      response => {

        if (response.status == 'success') {
          this.loading = false;
          this.poListDestruction = response.data;
          this.poSelected = "";
        }
      },
      error => {
        console.log(<any>error);
      });
  }

  selectChangeHandlerDestruction(event: any) {

    this.poSelectedDestruction = event.target.options[event.target.options.selectedIndex].text;
    this.getReport();
  }

  getReport() {
    this.cerrado = false;
    this.responseDestructionReport = [];
    this._reportService.getReportByPo(this.token, this.poSelectedDestruction, null, this.typeReport === 'detail' ? "DETAILEDPHYSICALDESTRUCTION" : "PHYSICALDESTRUCTION").subscribe(
      response => {
        console.log(response);
        this.destructionpo = this.poSelectedDestruction;
        if (response.status == 'success') {
          this.cerrado = (response.data.name !== 'pending');
          this.desbloquear = true;
          this.currentReport = response.data.id;
          console.log(this.currentReport);
          this.statusContainerByPhysicalDestruction = true;
          this.destructionposelected = this.poSelectedDestruction;
          this.getReports();
        } else {
          this.currentReport = 0;
        }
      },
      error => {
        console.log(<any>error);
      }
    );

  }

  public perPage = '150';
  public page = 1;
  public showingNav = 0;
  public showingTo = 0;
  public total_items_count = 0;
  public total_pages = 0;
  public pages = [];

  goToPage(page) {
    this.page = page;
    this.getReports();
  }

  getReports() {
    this.responseDestructionReport = [];
    this.summaryTotal = {};
    if (this.currentReport != 0) {
      this._reportService.getDiscs(this.token, this.currentReport, this.page, this.perPage).subscribe(
        r => {
          console.log(r);

          this.page = Number(r.page_actual);
          this.perPage = String(r.items_per_page);
          this.total_items_count = Number(r.total_items_count);
          this.total_pages = Number(r.total_pages);

          this.showingTo = this.page * Number(this.perPage);
          this.showingNav = (this.page * Number(this.perPage)) - (Number(this.perPage) - 1);

          let valorfor = this.page - 2;
          if  (valorfor < 0) { valorfor = 0; }
            this.pages = [];
            let cont = 0;
            for (let i = valorfor; i < Number(r.total_pages); i++) {
              let vaalortest = this.page - i;
              // console.log(vaalortest);
              this.pages.push(i);
              cont++;
              if (cont > 5) { break; }
            }

          for (let item of r.data) {

            let reporte = JSON.parse(item.data);
            reporte.id = item.id;
            let userREP = item.user;
            userREP = item.user.name[0]+item.user.surname[0];
            reporte.user = userREP;

            if (typeof this.summaryTotal[userREP] !== 'undefined') {
                this.summaryTotal[userREP]++;
            } else {
              this.summaryTotal[userREP] = 1;
            }

            this.responseDestructionReport.push(reporte);
          }

          this.responseDestructionReport.sort(((a, b) => b.id - a.id ));
          console.log(this.responseDestructionReport);
          $("#destructionhdresults").show();

          console.log(this.summaryTotal);
        }
      );
    }
  }

  saveDestructionReport() {
    this.reportSaved = 0;
    this.saving = true;
    let fechaHoy = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    console.log(fechaHoy);
    // this.responseDestructionReport.push({"clientsname": this.destructionclientsname});
    // var myJSON = JSON.stringify(this.responseDestructionReport);

    let dataEnviar = {
      user_id: this.identity.sub,
      po: this.poSelectedDestruction,
      name: fechaHoy,
      type: this.typeReport === 'detail' ? "DETAILEDPHYSICALDESTRUCTION" : "PDTEMP",
      data: null
    };
    if (this.currentReport > 0) {
      this.saveDisk();
      /*
        this._reportService.update(this.token, this.currentReport, dataEnviar).subscribe(
          response => {
            console.log(response);
            if (response.status == 'success') {
              this.reportSaved = 1;
              this.currentReport = response.data.id;
            }
          },
          error => {
            console.log(<any>error);
          });
      */
    } else {
      this._reportService.new(this.token, dataEnviar).subscribe(
        response => {
          if (response.code === 400 && response.msg === 'Authorization not valid') {
            this.mtds.notifyError('Your session has expired');
            localStorage.clear();
            this._router.navigate(['/pages/lock']);
            this.saving = false;
          } else if (response.status === 'success') {
            console.log(response);
            this.reportSaved = 1;
            this.currentReport = response.data.id;
            this.saveDisk();
          } else {
            this.mtds.notifyError(response.msg, response.code);
            this.saving = false;
          }
        }, error => {
          this.mtds.notifyError(error.statusText, error.status);
          this.saving = false;
        }
      );
    }
  }

  saveDisk() {
    console.log('holis');
    let idrandom = Math.floor((Math.random() * 100) + 1);
    this.destructionManuallySerialNumber = this.destructionManuallySerialNumber.replace(".", "");
    let serialnumberenviar = this.destructionManuallySerialNumber;
    let erasuredateneviar = this.destructionManuallyDate;
    let json: any = {
      id: idrandom,
      SerialNumber: serialnumberenviar,
      ErasureEndDate: erasuredateneviar,
      clientsname: this.destructionclientsname
    }

    if (this.typeReport === 'detail') {
      json = {
        id: idrandom,
        make: this.destructionManuallyMake,
        model: this.destructionManuallyModel,
        capacity: this.destructionManuallySerialCapacity,
        SerialNumber: serialnumberenviar,
        ErasureEndDate: erasuredateneviar,
        clientsname: this.destructionclientsname
      }
    }
    this._reportService.enviarDisco(this.token, this.currentReport, json).subscribe(
      response => {
        console.log(response);
        if (response.code === 400 && response.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (response.status === 'success') {
          this.destructionManuallySerialNumber = '';
          this.getReports();

        } else {
          this.mtds.notifyError(response.msg, response.code);
        }
        this.saving = false;
      }, error => {
        this.mtds.notifyError(error.statusText, error.status);
        this.saving = false;
      }
    );
  }

  generateDestructionReport() {
    let fechaHoy = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    console.log(fechaHoy);
    this.responseDestructionReport.push({ "clientsname": this.destructionclientsname });
    var myJSON = JSON.stringify(this.responseDestructionReport);
    let dataEnviar = {
      "user_id": this.identity.sub,
      "po": this.destructionpo,
      "name": fechaHoy,
      "type": this.typeReport === 'detail' ? "DETAILEDPHYSICALDESTRUCTION" : "PHYSICALDESTRUCTION",
      "data": myJSON
    }
    if (this.currentReport > 0) {
      this._reportService.update(this.token, this.currentReport, dataEnviar).subscribe(
        response => {
          console.log(response);
          if (response.status == 'success') {
            this.cerrado = true;
            var r = confirm("Press Ok to see report");
            if (r == true) {
              window.open("https://www.itaderp.com/backend/reports/view-report.php?id=" + response.data.id + "&typeReport=" + response.data.type + "", "_blank");
              this.responseDestructionReport = [];
            } else { }
          }
        },
        error => {
          console.log(<any>error);
        });
    } else {
      this._reportService.new(this.token, dataEnviar).subscribe(
        response => {
          console.log(response);
          if (response.status == 'success') {
            this.cerrado = true;
            var r = confirm("Press Ok to see report");
            if (r == true) {
              window.open("https://www.itaderp.com/backend/reports/view-report.php?id=" + response.data.id + "&typeReport=" + response.data.type + "", "_blank");
              this.responseDestructionReport = [];
            } else { }
          }
        },
        error => {
          console.log(<any>error);
        });
    }
  }

  AddDestructionManually() {
    this.reportSaved = 0;
    console.log(this.destructionManuallySerialNumber);
    let idrandom = Math.floor((Math.random() * 100) + 1);
    this.destructionManuallySerialNumber = this.destructionManuallySerialNumber.replace(".", "");
    let serialnumberenviar = this.destructionManuallySerialNumber;
    let erasuredateneviar = this.destructionManuallyDate;

    let enviar: any = {
      "id": idrandom,
      "SerialNumber": serialnumberenviar,
      "ErasureEndDate": erasuredateneviar,
      "clientsname": this.destructionclientsname
    }

    if (this.typeReport === 'detail') {
      enviar = {
        id: idrandom,
        make: this.destructionManuallyMake,
        model: this.destructionManuallyModel,
        capacity: this.destructionManuallySerialCapacity,
        SerialNumber: serialnumberenviar,
        ErasureEndDate: erasuredateneviar,
        clientsname: this.destructionclientsname
      }
    }
    console.log(enviar);
    console.log(this.responseDestructionReport);
    var found = this.responseDestructionReport.find(function (element) {


      if (typeof element.SerialNumber === 'undefined') {

      } else {
        return element.SerialNumber == serialnumberenviar;

      }

    });
    console.log(found);
    if (found) {

      //this.addToMastershowMsgInfoResults = 1;
      return true;
    }

    console.log(this.responseDestructionReport);
    if (this.responseDestructionReport.unshift(enviar)) {
      enviar = null;
      console.log(this.responseDestructionReport);
      $("#destructionhdresults").show();
      this.destructionManuallySerialNumber = '';
      console.log(this.destructionManuallySerialNumber);
      this.saveDestructionReport();
    }


  }

  removeDisk(id) {

    swal.fire({
      title: '',
      text: 'Do you want to remove this element?',
     
      showCancelButton: true,
      buttonsStyling: false,
   
      customClass:{
    confirmButton: 'btn btn-warning',
    cancelButton: 'btn btn-default',
            },
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then(function (result) {
      if (result.value) {
        this._reportService.removeDiscs(this.token, id).subscribe(
          response => {
            console.log(response);
            if (response.status === 'success') {

              this.getReports();
              this.mtds.notifySuccess(
                'The element has been removed successfully'
                );
            } else {
              this.mtds.notifyError(response.msg, response.code);
            }
          }, error => {
            this.mtds.notifyError(error.statusText, error.status);
          }
        );
      }
    }.bind(this));
  }

  canUnlock() {
    return this.gui.permissions('unlockPhDR');
  }

  unlock() {
    this.saveunlock = true;
    this._reportService.unlockReport(this.token, this.currentReport).subscribe(
      response => {
        console.log(response);
        this.cerrado = false;
        this.saveunlock = false;
      }, error => {
        console.log(error);
      }
    );
  }

}
